module.exports = __webpack_public_path__ + "static/LaunchApps-4032f0aa9d3b467628ca0c50e6962ac4.png";